import type { UseSuspenseQueryResult } from "@tanstack/react-query";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { OffersSchemas } from "api-types";
import { AxiosError, type AxiosResponse } from "axios";
import { useNavigate } from "react-router";

import { useOfferRequestPath } from "../hooks/use-offer-request-path";

export const useGetOffersQuery = (
  productRequestId?: string | null
): UseSuspenseQueryResult<OffersSchemas.PublishedOfferSchema> => {
  const client = useAxios();
  const navigate = useNavigate();
  const offerPaths = useOfferRequestPath();
  const requestPath = offerPaths.getPublishedOffers(productRequestId);
  return useSuspenseQuery({
    queryKey: [requestPath],
    queryFn: () => client.get<null>(requestPath),
    meta: {
      onError: (error: AxiosError) => {
        if (error.status === 404) {
          navigate(offerPaths.viewCustomerRoot());
        }
      },
    },
    select: ({ data }: AxiosResponse) => data,
  });
};
